import { StateCreator } from "zustand";
import { BookingDetailsDto } from "~/api/GeneratedApi";
import { StoreState } from "../useBoundStore";

export type FilterDataTypes<T extends object> = {
  filteredData: T[];
  setFilteredData: (d: T[]) => void;
};

export const createMaterialTableFilteredSlice: StateCreator<
  StoreState,
  [],
  [],
  FilterDataTypes<BookingDetailsDto>
> = (set) => ({
  filteredData: [],
  setFilteredData: (data) =>
    set(() => {
      return { filteredData: data };
    }),
});
